import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function PrixResumes() {
  const { t } = useTranslation('blogprix');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  const rows = [
    { materiau: 'resume_1_materiau', fourchette: 'resume_1_fourchette', duree: 'resume_1_duree' },
    { materiau: 'resume_2_materiau', fourchette: 'resume_2_fourchette', duree: 'resume_2_duree' },
    { materiau: 'resume_3_materiau', fourchette: 'resume_3_fourchette', duree: 'resume_3_duree' },
    { materiau: 'resume_4_materiau', fourchette: 'resume_4_fourchette', duree: 'resume_4_duree' },
  ];

  return (
    <section ref={ref} id="resume" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-6 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('resume_h2')}
      </h2>

      <div className={`overflow-x-auto transition-all duration-1000 delay-150 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-primary text-white">
              <th className="px-4 py-3 text-sm font-semibold rounded-tl-lg">{t('resume_th_materiau')}</th>
              <th className="px-4 py-3 text-sm font-semibold">{t('resume_th_fourchette')}</th>
              <th className="px-4 py-3 text-sm font-semibold rounded-tr-lg">{t('resume_th_duree')}</th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {rows.map((row, idx) => (
              <tr key={idx} className={`border-b border-soft-gray ${idx % 2 === 1 ? 'bg-soft-gray/30' : ''}`}>
                <td className="px-4 py-3.5 text-sm text-slate-primary font-medium">{t(row.materiau)}</td>
                <td className="px-4 py-3.5 text-sm text-copper font-bold">{t(row.fourchette)}</td>
                <td className="px-4 py-3.5 text-sm text-slate-primary/60">{t(row.duree)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className={`text-xs text-slate-primary/40 mt-3 italic transition-all duration-1000 delay-300 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}>
        {t('resume_note')}
      </p>
    </section>
  );
}